<template>
  <div>
    <el-card class="box-card tablecard" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Statistics of file size and file count by project</span>
      </div>
      <div>
        <div class="mb10 textRight">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div>
        <el-table
          v-loading="loading"
          @sort-change="handleSort"
          :sortable="false"
          :data="tableData"
          height="800"
          border
          stripe
          style="width: 100%">
          <el-table-column
            prop="lab_head"
            label="Lab Head"
            
            width="150"
            sortable>
          </el-table-column>
          <el-table-column
            prop="project_id"
            label="Project Id"
            width="130"
            sortable>
            <template slot-scope="scope">
              <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                {{scope.row.project_id}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="project_name"
            label="Project title"
            sortable>
          </el-table-column>
          <el-table-column
            prop="institution"
            label="Institution"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="file_count"
            label="File Count"
            header-align="left"
            align="right"
            width="90"
            sortable>
            <template #header>
              <span class="wrap-header">File<br>Count</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="file_size"
            label="File Size(GB)"
            header-align="left"
            align="right"
            width="110"
            sortable>
            <template #header>
              <span class="wrap-header">File<br>Size (GB)</span>
            </template>
          </el-table-column>
          <el-table-column
            width="110"
            prop="release_date"
            label="Release Date"
            sortable>
            <template #header>
              <span class="wrap-header">Release<br>Date</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="allNum"
          :page-size="pageSize"
          @current-change="handleChangepage"
          class="pagination mb10">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatDownloadDateCv, getStatProjectFilesize } from '@/api'
import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      isOverflow: true,
      tableData: [],
      ajax_data_list: {
        search:{
          keyword: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: "",
          type: "desc"
        }
      },
      pageSize: 20,
      allNum: 0,
      loading: true,
      orderConvert: {
        ascending: 'asc',
        descending: 'desc'
      },
      searchkey: ''
    }
  },
  mounted() {
  },
  created() {
    getStatProjectFilesize(this.ajax_data_list).then(res => {
      // console.log(res.result)
      this.loading = false
      this.allNum = res.count
      let newData = res.result
      // newData.forEach((val, index) => {
      //   // let fileCount = val.file_count;
      //   // if(val.file_size != undefined || val.file_size != '' || val.file_size != null) {
      //   //   let fileSize = this.handleFilesize(val.file_size)
      //   //   val.file_size = fileSize
      //   // }
      //   let fileSize = this.handleFilesize(val.file_size)
      //   val.file_size = fileSize
      // })
      this.tableData = newData
    })
  },
  methods: {
    handleSearch() {
      this.loading = true
      this.ajax_data_list.search.keyword = this.searchkey
      this.ajax_data_list.page.pageLength = 20
      this.ajax_data_list.page.startPage = 1
      getStatProjectFilesize(this.ajax_data_list).then(res => {
        this.loading = false
        let newData = res.result
        // newData.forEach((val, index) => {
        //   // let fileCount = val.file_count;
        //   // let fileSize = this.handleFilesize(val.file_size)
        //   // val.fileCount = fileCount + fileSize
        //   let fileSize = this.handleFilesize(val.file_size)
        //   val.file_size = fileSize
        // })
        this.tableData = newData
        this.allNum = res.count
      })
    },
    handleChangepage (val) {
      this.loading = true
      this.ajax_data_list.page.startPage = val
      getStatProjectFilesize(this.ajax_data_list).then(res => {
        this.loading = false
        let newData = res.result
        // newData.forEach((val, index) => {
        //   // let fileCount = val.file_count;
        //   // let fileSize = this.handleFilesize(val.file_size)
        //   // val.fileCount = fileCount + fileSize
        //   let fileSize = this.handleFilesize(val.file_size)
        //   val.file_size = fileSize
        // })
        this.tableData = newData
        this.allNum = res.count
      })
    },
    handleSort (column, prop, order) {
      // console.log(column, prop, order)
      this.loading = true
      this.ajax_data_list.order.item = column.prop
      this.ajax_data_list.order.type = this.orderConvert[column.order]
      this.ajax_data_list.page.pageLength = this.pageSize
      if (column.order !== null && column.prop !== null) {
        getStatProjectFilesize(this.ajax_data_list).then(res => {
          this.loading = false
          let newData = res.result
          console.log(newData)
          // newData.forEach((val, index) => {
          //   // let fileCount = val.file_count;
          //   // let fileSize = this.handleFilesize(val.file_size)
          //   // val.fileCount = fileCount + fileSize
          //   let fileSize = this.handleFilesize(val.file_size)
          //   val.file_size = fileSize
          // })
          console.log(newData)
          this.tableData = newData
          console.log(this.tableData)
          this.allNum = res.count
        })
      } else {
        this.loading = false
      }
    },
    handleGetStatData() {
      this.loading = true
      getStatProjectFilesize(this.ajax_data_list).then(res => {
        // console.log(res.result)
        this.loading = false
        this.allNum = res.count
        let newData = res.result
        // newData.forEach((val, index) => {
        //   let fileCount = val.file_count;
        //   let fileSize = this.handleFilesize(val.file_size)
        //   val.fileCount = fileCount + fileSize
        // })
        this.tableData = newData
      })
    },
    handleProurl(param) {
      let routerData = this.$router.resolve({path: '/project', query: {id: param}})
      window.open(routerData.href, '_blank')
    },
    handleFilesize2(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = ' (' + 0 +'K)';
      } else if (fileSize < 1024) {
        fileSize = ' (' + fileSize.toFixed(2) + 'K)';
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize =  ' (' + (fileSize / 1024).toFixed(2)+ 'M)'
      } else {
        fileSize =   ' ('
          + (fileSize / 1024 / 1024).toFixed(2)
          + 'G)'
      }
      return fileSize
    },
    handleFilesize(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = 0 +'K';
      } else if (fileSize < 1024) {
        fileSize = fileSize.toFixed(2) + 'K';
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize =  (fileSize / 1024).toFixed(2)+ 'M'
      } else {
        fileSize =  (fileSize / 1024 / 1024).toFixed(2)
          + 'G'
      }
      return fileSize
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
